module.exports = __webpack_public_path__ + "static/canadagamescenter-logo-490fa8027418bb1b7d04747886cae11e.png";